import { withHandlers } from 'recompose';

export default withHandlers({
    notifyLernieChatEnded: ({ showDebrief, closeLernieChat, lifeCycleLernieEndedDebrief, lifeCycleLernieEndedSpeaking}) => () => {
        closeLernieChat();
        !showDebrief && lifeCycleLernieEndedSpeaking(); 
        showDebrief && lifeCycleLernieEndedDebrief(); 
    }
});
